import {Step} from "react-joyride";
import {createReducer} from "redux-act";
import {
	openTutorial,
	closeTutorial,
	setActiveStep,
	setIsOpenMobileNavigation,
	openTutorialSingleStep,
	closeTutorialSingleStep,
} from "modules/actions";

export interface ITutorial {
	isOpen: boolean;
	step: number;
	isOpenMobileNavigation: boolean;
	singleStep: Step | null;
}

const initialState: ITutorial = {
	isOpen: false,
	step: 0,
	isOpenMobileNavigation: false,
	singleStep: null,
};

const onOpenTutorial = (state: ITutorial) => ({
	...state,
	isOpen: true,
	step: 0,
	isOpenMobileNavigation: false,
});

const onCloseTutorial = (state: ITutorial) => ({
	...state,
	isOpen: false,
	isOpenMobileNavigation: false,
});

const onSetActiveStep = (state: ITutorial, payload: number) => ({
	...state,
	step: payload,
});

const onSetIsOpenMobileNavigation = (state: ITutorial, payload: boolean) => ({
	...state,
	isOpenMobileNavigation: payload,
});

const onOpenTutorialSingleStep = (state: ITutorial, payload: Step) => ({
	...state,
	singleStep: payload,
});

const onCloseTutorialSingleStep = (state: ITutorial) => ({
	...state,
	singleStep: null,
});

export const tutorial = createReducer({}, initialState)
	.on(openTutorial, onOpenTutorial)
	.on(closeTutorial, onCloseTutorial)
	.on(setActiveStep, onSetActiveStep)
	.on(setIsOpenMobileNavigation, onSetIsOpenMobileNavigation)
	.on(openTutorialSingleStep, onOpenTutorialSingleStep)
	.on(closeTutorialSingleStep, onCloseTutorialSingleStep);
